<template>
	<div id="map-optimization-container" class="map-custom-container vs-con-loading__container">
		<vs-row vs-w="12">
			<vs-col
				vs-justify="center"
				vs-align="center"
				:vs-lg="isARouteSelected || isVisitPointSelected ? '8' : '12'"
				vs-sm="12"
				vs-xs="12"
			>
				<vx-card no-shadow card-border>
					<GoogleMaps
						id="map-google-optimization"
						class="mt-2"
						ref="GoogleMaps"
						name="map-routing"
						latitude="4.686699"
						longitude="-74.0837187"
						zoom="13"
						theme="blue_essence"
					></GoogleMaps>
				</vx-card>
			</vs-col>
			<transition name="slide-fade">
				<vs-col
					v-if="isARouteSelected"
					vs-justify="center"
					vs-align="center"
					:vs-lg="isARouteSelected ? '4' : '0'"
					vs-sm="12"
					vs-xs="12"
				>
					<vx-card
						no-shadow
						card-border
						style="height: 100%"
						:title="currentRouteData.vehicle_id"
						:subtitle="currentRouteData.vehicle_id"
					>
						<template slot="actions">
							<feather-icon
								:icon="'XIcon'"
								svgClasses="w-5 h-5 m-1"
								class="cursor-pointer bg-primary text-white rounded-full"
								@click="closeResourceSelected"
							/>
						</template>
						<hr
							:style="`width:100%;height:5px;border-width:0;color:gray;background-color:#${currentRouteData.color}`"
						/>
						<vue-perfect-scrollbar class="scroll-area" :settings="settings">
							<vx-card no-shadow>
								<table style="width: 100%" class="border-collapse" v-if="isARouteSelected">
									<caption></caption>
									<tr>
										<th
											class="p-2 border border-solid d-theme-border-grey-light text-center"
											scope="col"
										>
											{{ $t("Routing.DistanceRoute") }}
											(Km)
										</th>
										<th
											colspan="2"
											class="p-2 border border-solid d-theme-border-grey-light text-center"
											scope="col"
										>
											<div class="flex items-center justify-center">
												{{ $t("ResourceModule.TotalCost") }}
												<i
													v-if="!validateCost(currentRouteData.costs)"
													class="material-icons ml-2 text-primary cursor-pointer"
													style="font-size: 15px"
													@click.prevent="showPopupCosts(currentRouteData.costs)"
													>visibility
												</i>
											</div>
										</th>
									</tr>
									<tr>
										<td class="p-2 border border-solid d-theme-border-grey-light text-center">
											{{ currentRouteData.distance_route | removeDecimals }}
										</td>
										<td
											colspan="2"
											class="border border-solid d-theme-border-grey-light text-center"
										>
											<span>{{
												currentRouteData.costs.total != null
													? currentRouteData.costs.total.toFixed(3)
													: 0
											}}</span>
										</td>
									</tr>
									<tr>
										<th class="p-2 border border-solid d-theme-border-grey-light" scope="col">
											{{ $t("RouterSelection.VisitPoints") }}
										</th>
										<th
											class="p-2 border border-solid d-theme-border-grey-light flex items-center justify-center"
											scope="col"
										>
											{{ $t("Routing.RouteResult.Capacities") }}
											<i
												v-if="currentRouteData.vehicle_capacity.length > 0"
												class="material-icons ml-2 text-primary cursor-pointer"
												style="font-size: 15px"
												@click.prevent="showPopupCapacities(currentRouteData)"
												>visibility
											</i>
										</th>
										<th
											class="p-2 border border-solid d-theme-border-grey-light text-center"
											scope="col"
										>
											{{ $t("Skills.Skills") }}
										</th>
									</tr>
									<tr>
										<td class="p-2 border border-solid d-theme-border-grey-light text-center">
											{{ currentRouteData.total_visit_points }}
										</td>
										<td class="p-2 border border-solid d-theme-border-grey-light text-center">
											{{
												currentRouteData.hasOwnProperty("vehicle_capacity") &&
												currentRouteData.vehicle_capacity != null
													? currentRouteData.vehicle_capacity.length
													: 0
											}}
										</td>
										<td class="p-2 border border-solid d-theme-border-grey-light text-center">
											{{
												currentRouteData.hasOwnProperty("vehicle_skills") &&
												currentRouteData.vehicle_skills != null
													? currentRouteData.vehicle_skills.length
													: 0
											}}
										</td>
									</tr>
									<tr>
										<th class="p-2 border border-solid d-theme-border-grey-light" scope="col">
											{{ $t("Routing.RouteResult.DrivingTimme") | title }}
										</th>
										<th
											class="p-2 border border-solid d-theme-border-grey-light text-center"
											scope="col"
										>
											{{ $t("Routing.CreateVisitPoint.ServiceTime") }}
										</th>
										<th class="p-2 border border-solid d-theme-border-grey-light" scope="col">
											{{ $t("Routing.MinimumRouteTime") }}
										</th>
									</tr>
									<tr>
										<td class="p-2 border border-solid d-theme-border-grey-light">
											{{ currentRouteData.minimum_driving_time }}
										</td>
										<td class="border border-solid d-theme-border-grey-light text-center">
											{{ currentRouteData.minimum_time_service }}
										</td>
										<td class="p-2 border border-solid d-theme-border-grey-light">
											{{ currentRouteData.minimum_route_time }}
										</td>
									</tr>
								</table>
							</vx-card>
							<routing-result-visit-points
								:routed_visit_points="tableData"
								:thead_property_names="thead_property_names"
								:typeRouting="selectedRoutingType"
								:selected-rows="selectedTableRows"
								@handleSelectedEmit="handleSelected"
							>
								<div slot="header">
									<p class="font-bold">
										{{ $t("Routing.Title.VisitPoints") }}
									</p>
								</div>
							</routing-result-visit-points>
						</vue-perfect-scrollbar>
					</vx-card>
				</vs-col>
				<vs-col
					v-else-if="isVisitPointSelected"
					vs-justify="center"
					vs-align="center"
					:vs-lg="isVisitPointSelected ? '4' : '0'"
					vs-sm="12"
					vs-xs="12"
				>
					<visiting-point-details :visitPointDetails="visitPointDetails" @closeSidebar="closeSidebar" />
				</vs-col>
			</transition>
		</vs-row>
		<vs-popup
			id="export-with-loading"
			class="vs-con-loading__container"
			:title="$t('Routing.RouteResult.Title')"
			:active.sync="exportRouteModal"
		>
			<div id="export-route-modal-content" class="vs-con-loading__container">
				<div class="vx-row">
					<div class="vx-col w-full flex items-center">
						<div class="w-full">
							<small class="date-label">{{ $t("Routing.Title.SelectFormat") }}</small>
							<v-select
								class="w-full"
								v-model="formatSelect"
								value="value"
								label="text"
								:placeholder="$t('Select')"
								:clearable="false"
								:options="formatOptions"
								:dir="$vs.rtl ? 'rtl' : 'ltr'"
							>
								<template v-slot:no-options="{search, searching}">
									<template v-if="searching">
										{{ $t("NoResultsFoundFor") + " " }}<em>{{ search }}</em>
									</template>
									<template v-else>
										{{ $t("NoResultsFound") }}
									</template>
								</template>
							</v-select>
						</div>
						<vs-dropdown
							vs-custom-content
							vs-trigger-click
							class="cursor-pointer mt-6"
							:title="$t('Setting.Setting')"
						>
							<vs-button class="ml-2" type="filled" icon-pack="feather" icon="icon-sliders"></vs-button>
							<vs-dropdown-menu style="z-index: 54000" class="loginx">
								<div class="flex items-center justify-between p-4">
									<div class="pr-4">
										<h3>{{ $t("ManageFields") }}</h3>
										<p>{{ $t("SortAndSelectTheFieldsToBeExported") }}</p>
									</div>
									<feather-icon
										icon="RefreshCwIcon"
										class="cursor-pointer text-primary mr-2 font-bold"
										:title="$t('RestoringOrder')"
										@click.stop="orderList"
									></feather-icon>
									<vs-checkbox
										v-model="is_check"
										:title="!is_check ? $t('RouterSelection.CheckedAll') : $t('ClearSelection')"
									/>
								</div>
								<vue-perfect-scrollbar class="scroll-area-order" :settings="settings">
									<draggable
										class="list-group"
										tag="ul"
										v-model="listOrderColumn"
										v-bind="dragOptions"
									>
										<transition-group type="transition" name="flip-list">
											<vs-list v-for="item in listOrderColumn" :key="item.order">
												<vs-list-item
													class="list-group-item"
													aria-hidden="true"
													:title="item.name"
												>
													<vs-checkbox v-model="item.is_check" color="primary" />
												</vs-list-item>
											</vs-list>
										</transition-group>
									</draggable>
								</vue-perfect-scrollbar>
							</vs-dropdown-menu>
						</vs-dropdown>
					</div>
				</div>
				<vx-card no-shadow>
					<vue-perfect-scrollbar class="scroll-area--export" :settings="settings">
						<vs-table
							v-if="routedVehicles.length > 0"
							multiple
							v-model="selected"
							pagination
							max-items="10"
							search
							:data="routedVehicles"
						>
							<template slot="header">
								<p>
									{{ $t("Routing.Title.SelectResource") }}
								</p>
							</template>
							<template slot="thead">
								<vs-th>{{ $t("Vehicles.Vehicles") }}</vs-th>
								<vs-th>{{ $t("Routing.DistanceRoute") }}</vs-th>
								<vs-th>{{ $t("Routing.MinimumRouteTime") }}</vs-th>
							</template>
							<template slot-scope="{data}">
								<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
									<vs-td>
										<p class="product-category normal-case">
											{{ tr.vehicle_id }}
										</p>
									</vs-td>
									<vs-td>{{ tr.distance_route }}</vs-td>
									<vs-td>{{ tr.minimum_route_time }}</vs-td>
								</vs-tr>
							</template>
						</vs-table>
					</vue-perfect-scrollbar>
				</vx-card>
				<div
					class="flex items-center"
					:class="
						validateTypeFormats === 'xlsx' || validateTypeFormats === 'json'
							? 'justify-between'
							: 'justify-end'
					"
				>
					<div
						v-if="validateTypeFormats === 'xlsx' || validateTypeFormats === 'json'"
						class="flex items-center ml-2"
						:title="$t('DeterminesPageStatistics')"
					>
						<vs-checkbox class="m-0 p-0" v-model="is_statistics" />
						<label class="font-bold" style="font-size: 14px">{{ $t("AddVehicleStatistics") }}</label>
					</div>
					<vs-button
						:title="$t('Routing.Map.Schedule.ClickToSchedule')"
						:disabled="!formatSelect || selected.length <= 0"
						@click="exportRoute"
						>{{ $t("UploadFiles.Download") }}
					</vs-button>
				</div>
			</div>
		</vs-popup>
		<vs-popup
			id="schedule-with-loading"
			class="vs-con-loading__container vs-popup-schedule-content p-4"
			:title="$t('Routing.Title.Schedule') + ' ' + this.$t('In') + ' ' + 'Datarutas'"
			:active.sync="scheduleModal"
		>
			<div
				v-if="
					(infoDetailsVehicleList.length > 0 && isInfoDetails) ||
					(infoDetailsWaypointList.length > 0 && isInfoWaypointDetails)
				"
				class="rounded-b-lg text-primary w-full p-2 border border-b-1 border-l-0 border-r-0 border-solid d-theme-border-grey-light flex items-center justify-between"
			>
				<span
					v-if="isInfoDetails || isInfoWaypointDetails"
					class="flex items-center font-bold cursor-pointer ml-2 hover:text-warning"
					@click="backSchedule"
				>
					<feather-icon
						:title="$t('Notification.DeleteAllNotifications')"
						icon="ArrowLeftIcon"
						class="cursor-pointer"
						:svgClasses="['stroke-current h-6 w-6']"
					/>{{ $t("Back") }}
				</span>
			</div>
			<list-selected-datarutas-visit-points
				v-if="infoDetailsVehicleList.length > 0 && isInfoDetails"
				:visit_point_selected="infoDetailsVehicleList"
				:selectedInfoDetails="selectedInfoDetails"
			/>
			<list-selected-datarutas-wapoints
				v-else-if="typeSchedule === 'waypoint' && infoDetailsWaypointList.length > 0 && isInfoWaypointDetails"
				:waypointSelected="infoDetailsWaypointList"
				:selectedInfoDetails="selectedInfoDetails"
				:dataFilterWaypoint="dataHeaderWaypoint"
				@closeScheduleEmit="closeSchedule"
			/>
			<div v-else>
				<vx-card no-shadow card-border class="mb-2">
					<h4 class="mb-2">{{ $t("TypeOfSchedule") }}</h4>
					<cite>{{ $t("DefinesHowTheSelectedRoutesWill") }}</cite>
					<div class="flex items-center justify-between mb-2 mt-4">
						<ul class="centerx flex items-center">
							<li>
								<vs-radio v-model="typeSchedule" vs-name="radios1" vs-value="standard" class="mr-6">{{
									$t("Standard")
								}}</vs-radio>
							</li>
							<li>
								<vs-radio v-model="typeSchedule" vs-name="radios1" vs-value="waypoint">{{
									$t("WithWaypoints")
								}}</vs-radio>
							</li>
						</ul>
						<div v-if="typeSchedule === 'waypoint'" class="flex items-center justify-start">
							<label>{{ $t("IncludeDeposits") }}</label>
							<vs-switch class="ml-2" color="success" v-model="includeDepots" />
						</div>
					</div>
					<div class="vx-row flex items-center justify-end mt-4">
						<div class="vx-col w-full hidden lg:block md:w-3/4">
							<vs-input
								:placeholder="$t('Search')"
								v-model="searchQuery"
								icon="icon-search"
								icon-pack="feather"
								class="w-full"
							/>
						</div>
						<div class="vx-col w-full md:w-1/4">
							<vs-button
								class="w-full"
								:title="$t('Routing.Map.Schedule.ClickToSchedule')"
								:disabled="selected.length <= 0"
								@click="scheduleRoute"
								>{{ typeSchedule === "waypoint" ? $t("Manage") : $t("Routing.Buttons.Schedule") }}
							</vs-button>
						</div>
					</div>
				</vx-card>
				<span class="font-semibold ml-2">{{ $t("Routing.Messages.SelectSchedule") }}</span>
				<vs-table
					multiple
					v-model="selected"
					:data="getRoutedVehicles"
					pagination
					max-items="10"
					class="w-full mt-2"
				>
					<template slot="thead">
						<vs-th>{{ $t("Routing.Resource") }}</vs-th>
						<vs-th>{{ $t("Routing.DistanceRoute") }}</vs-th>
						<vs-th>{{ $t("Routing.MinimumRouteTime") }}</vs-th>
						<vs-th
							v-if="
								is_error_schedule || (typeSchedule === 'waypoint' && scheduleWaypointDetails.length > 0)
							"
							>{{ $t("Teams.Table.Action") }}</vs-th
						>
					</template>

					<template slot-scope="{data}">
						<tbody>
							<vs-tr
								:data="tr"
								:key="indextr"
								v-for="(tr, indextr) in data"
								:id="`tr-route-${tr.vehicle_id}`"
							>
								<vs-td>
									<p class="product-category normal-case">
										{{ tr.vehicle_id }}
									</p>
								</vs-td>
								<vs-td>{{ tr.distance_route }}</vs-td>
								<vs-td>{{ tr.minimum_route_time }}</vs-td>
								<vs-td
									v-if="typeSchedule != 'waypoint' && is_error_schedule"
									class="whitespace-no-wrap"
								>
									<feather-icon
										v-if="tr.showErrorSchedule"
										icon="AlertCircleIcon"
										class="mr-2"
										svgClasses="h-5 w-5 text-danger hover:text-warning cursor-pointer"
										:title="$t('ManualData.FixErrorsHere')"
										@click="seeDetailInformation(tr)"
									/>
									<feather-icon
										icon="CheckCircleIcon"
										svgClasses="h-5 w-5 cursor-pointer"
										:class="is_success_schedule ? 'text-success' : 'text-grey'"
										:title="$t('Setting.Saved')"
									/>
								</vs-td>
								<vs-td v-if="typeSchedule === 'waypoint' && scheduleWaypointDetails.length > 0">
									<feather-icon
										v-if="tr.showSchedule"
										icon="CalendarIcon"
										class="mr-2"
										svgClasses="h-5 w-5 hover:text-primary cursor-pointer"
										:title="$t('Routing.Map.Schedule.ClickToSchedule')"
										@click="seeWaypointDetailInformation(tr, indextr)"
									/>
								</vs-td>
							</vs-tr>
						</tbody>
					</template>
				</vs-table>
			</div>
		</vs-popup>
		<!-- MODAL SCHEDULE ERRORS RESULT -->
		<vs-popup :title="$t('Routing.Title.Schedule')" :active.sync="scheduleModalErrors">
			<h5 class="mb-2">
				{{ $t("Routing.Map.Schedule.NotScheduledVisits") }}:
				{{ lista.length }}
			</h5>
			<vue-perfect-scrollbar class="scroll-area-no-scheduled" :settings="settings">
				<vs-table :data="lista" v-model="selectedUsers">
					<template slot="thead">
						<vs-th>{{ $t("Visit") }}</vs-th>
						<vs-th> {{ $t("Error") }}</vs-th>
					</template>

					<template slot-scope="{data}">
						<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
							<vs-td>{{ indextr + 1 }}</vs-td>
							<vs-td>{{ tr.description }}</vs-td>
						</vs-tr>
					</template>
				</vs-table>
			</vue-perfect-scrollbar>
		</vs-popup>
		<vs-popup fullscreen :title="$t('Routing.RouteResult.Title')" :active.sync="popupActive">
			<OptimizationResult v-if="popupActive" />
		</vs-popup>
		<vs-popup :title="currentRouteData.vehicle_id" :active.sync="popupCapacityActive">
			<vue-perfect-scrollbar v-if="popupCapacityActive" :settings="settings">
				<vs-table
					v-if="capacityArray.length"
					ref="table"
					v-model="selected"
					search
					:max-items="itemsPerPage"
					:data="capacityArray"
				>
					<div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between mb-4">
						<label class="font-bold">{{
							$t("Capacity.TotalCapacities") + ": " + capacityArray.length
						}}</label>
					</div>
					<template slot="thead">
						<vs-th sort-key="name">{{ $t("Name") }}</vs-th>
						<vs-th sort-key="description">{{ $t("ResourceModule.Create.CapacityValue") }}</vs-th>
						<vs-th sort-key="loadCapacity">{{ $t("Routing.RouteResult.LoadCapacity") }}</vs-th>
						<vs-th sort-key="load">{{ "%" + " " + $t("Routing.RouteResult.Load") }}</vs-th>
					</template>

					<template slot-scope="{data}">
						<tbody>
							<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
								<vs-td>
									<p class="product-name font-medium truncate">{{ tr.name }}</p>
								</vs-td>
								<vs-td>
									<p class="product-category">{{ tr.amount }}</p>
								</vs-td>
								<vs-td>
									<p class="product-category">{{ getLoadCapacity(vehicleObject, tr.name) }}</p>
								</vs-td>
								<vs-td>
									<p class="product-category flex items-center">
										<vs-progress
											v-if="vehicleObject.load_capacity_percentage.length > 0"
											class="mr-2"
											:height="8"
											:percent="getLoadCapacityPercentage(vehicleObject, tr.name)"
											:color="chipColor(getLoadCapacityPercentage(vehicleObject, tr.name))"
										></vs-progress>
										{{ getLoadCapacityPercentage(vehicleObject, tr.name) + "%" }}
									</p>
								</vs-td>
							</vs-tr>
						</tbody>
					</template>
				</vs-table>
				<p v-else>
					{{ $t("Capacity.NoAssignedCapability") }}
				</p>
			</vue-perfect-scrollbar>
		</vs-popup>
		<vs-popup :title="currentRouteData.vehicle_id" :active.sync="popupCostActive">
			<vue-perfect-scrollbar v-if="popupCostActive" :settings="settings">
				<vs-table ref="table" v-model="selected" search :max-items="itemsPerPage" data="null">
					<div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between mb-4">
						<label class="font-bold">{{
							$t("ResourceModule.TotalCost") + ": " + this.costObject.total != null
								? this.costObject.total.toFixed(3)
								: 0
						}}</label>
					</div>
					<template slot="thead">
						<vs-th sort-key="distance">{{ $t("Optimization.Distance") }}</vs-th>
						<vs-th sort-key="fixed">{{ $t("Optimization.Fixed") }}</vs-th>
						<vs-th sort-key="time">{{ $t("Optimization.Time") }}</vs-th>
						<vs-th sort-key="traveledhour">{{ $t("Optimization.TraveledHour") }}</vs-th>
						<vs-th sort-key="vehicletime">{{ $t("Optimization.VehicleTime") }}</vs-th>
					</template>
					<template>
						<tbody>
							<vs-tr>
								<vs-td>
									<p class="product-category">
										{{ this.costObject.distance != null ? this.costObject.distance.toFixed(4) : 0 }}
									</p>
								</vs-td>
								<vs-td>
									<p class="product-category">
										{{ this.costObject.fixed != null ? this.costObject.fixed.toFixed(4) : 0 }}
									</p>
								</vs-td>
								<vs-td>
									<p class="product-category">
										{{ this.costObject.time != null ? this.costObject.time.toFixed(4) : 0 }}
									</p>
								</vs-td>
								<vs-td>
									<p class="product-category">
										{{
											this.costObject.traveled_hour != null
												? this.costObject.traveled_hour.toFixed(4)
												: 0
										}}
									</p>
								</vs-td>
								<vs-td>
									<p class="product-category">
										{{
											this.costObject.vehicle_time != null
												? this.costObject.vehicle_time.toFixed(4)
												: 0
										}}
									</p>
								</vs-td>
							</vs-tr>
						</tbody>
					</template>
				</vs-table>
			</vue-perfect-scrollbar>
		</vs-popup>
		<vs-popup
			id="export-with-loading"
			class="vs-con-loading__container vs-popup-schedule-content p-4"
			:title="$t('Territories.VisualizeTerritoriesOnTheMap')"
			:active.sync="showTerritories"
		>
			<vx-card no-shadow card-border class="mb-2">
				<h4 class="mb-2">{{ $t("Territories.Territories") }}</h4>
				<cite>{{ $t("Territories.TerritorySubtitle") }}</cite>
			</vx-card>
			<vs-table
				id="content-territory"
				multiple
				v-model="selectedTerritory"
				:data="territoryOptions"
				pagination
				max-items="10"
				class="w-full mt-2"
				search
			>
				<template slot="header">
					<vs-button
						class="md:w-1/4"
						:title="$t('Routing.Map.Schedule.ClickToSchedule')"
						:disabled="selectedTerritory.length <= 0"
						@click="drawTerritoriesAroundSelectedPoints()"
						>{{ $t("Territories.ViewTerritories") }}
					</vs-button>
				</template>
				<template slot="thead">
					<vs-th>{{ $t("Territories.Territory") }}</vs-th>
					<vs-th>{{ $t("Vehicles.Vehicle") }}</vs-th>
				</template>
				<template slot-scope="{data}">
					<tbody>
						<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" :id="`tr-route-${tr.value}`">
							<vs-td>
								<p class="product-category normal-case">
									{{ tr.value }}
								</p>
							</vs-td>
							<vs-td>
								<p class="product-category normal-case">
									{{ tr.vehicle_id }}
								</p>
							</vs-td>
						</vs-tr>
					</tbody>
				</template>
			</vs-table>
		</vs-popup>
		<optimization-errors
			:errorsActive="errorsActive"
			:optimizationErrors="optimizationErrors"
			@activePopupEmit="activePopup"
		/>
		<routing-sidebar
			:routed-vehicles="routedVehicles"
			:is-sidebar-active="showRoutes"
			:marker-list="markersArray"
			:polyline-list="polylines"
			:show-checkbox="!isARouteSelected"
			:componentParent="'OPTIMIZATION'"
			:index-validation="indexValidation"
			@loadIndividualRouteEmit="cargarRutaIndividual"
			@closeSidebar="toggleCloseSidebar"
		></routing-sidebar>
		<vs-prompt
			class="prompt-content"
			:title="$t('Optimization.CreateOptimization')"
			:active.sync="activePrompt"
			:acceptText="$t('Accept')"
			:cancelText="$t('Cancel')"
			:is-valid="validFormPrompt"
			@accept="acceptPrompt"
		>
			<optimization-create :optimizationObject="dataOptimization" @OptimizationFields="optimizationFields" />
		</vs-prompt>
		<vs-button
			v-if="showButton"
			color="danger"
			style="z-index: 0; position: absolute; right: 270px; top: 16px"
			icon-pack="feather"
			icon="icon-x"
			@click.prevent="ConfirmCancelChange"
			>{{ $t("Routing.Buttons.DiscardChanges") }}
		</vs-button>
		<vs-button
			v-if="showButton"
			style="z-index: 0; position: absolute; right: 60px; top: 16px"
			icon-pack="feather"
			icon="icon-refresh-cw"
			@click.prevent="showPrompt"
			>{{ $t("Routing.Buttons.ReOptimizeRoutes") }}
		</vs-button>
	</div>
</template>

<script>
import Api from "@/helpers/api.js";
import GoogleMaps from "@/components/Maps/Maps.vue";
import visitPointImg from "@/assets/images/markers/visit_point.png";
import dptoImg from "@/assets/images/markers/deposit/PinHome.svg";
import dptoImgEnd from "@/assets/images/markers/deposit/PinEnd.svg";
import {AgGridVue} from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moduleRouting from "@/store/routing/moduleRouting.js";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import RoutingResultVisitPoints from "./RoutingResultVisitPoints.vue";
import Utils from "@/helpers/Utils";
import DateUtils from "@/helpers/DateUtils.js";
import vSelect from "vue-select";
import RoutingSidebar from "@/components/optimization/RoutingSidebar";
import moduleOptimization from "@/store/optimization/moduleOptimization.js";
import OptimizationResult from "./OptimizationResult.vue";
import ListSelectedDatarutasVisitPoints from "@/components/optimization/ListSelectedDatarutasVisitPoints.vue";
import OptimizationCreate from "@/components/optimization/OptimizationCreate.vue";
import draggable from "vuedraggable";
import * as turf from "@turf/turf";
import {saveAs} from "file-saver";
import {
	customMapsControl,
	generateInfowindowContentPoint,
	generateInfowindowContentDeposit,
	generateInfowindowContentRoute,
	addIconToBtn,
} from "@/components/optimization/model/DinamicHtmlContentGenerator";
import OptimizationErrors from "./OptimizationErrors.vue";
import VisitingPointDetails from "./VisitingPointDetails.vue";
import ListSelectedDatarutasWapoints from "@/components/optimization/export-waypoint/ListSelectedDatarutasWaypoints.vue";

const fieldList = [
	"identification",
	"type",
	"longitude",
	"latitude",
	"estimated_time_arrival",
	"time_service",
	"estimated_time_depart",
	"distance_from_previous",
	"total_distance_traveled",
	"time_windows",
	"demand",
	"skills",
	"additional_info",
];

export default {
	name: "OptimizationMap",
	data() {
		return {
			itemsPerPage: 10,
			numberPerPages: 6,
			currentMarkerInfo: null,
			markers: {},
			infoWindowSelected: null,
			mapKey: 1,
			routeResultModal: false,
			deletePrompt: false,
			scheduleModal: false,
			includeDepots: false,
			rutas: {},
			visitPointDetails: {},
			tableData: [],
			arrayError: [],
			isARouteSelected: false,
			isVisitPointSelected: false,
			isInfoDetails: false,
			isInfoWaypointDetails: false,
			is_error_schedule: false,
			is_success_schedule: false,
			typeSchedule: "standard",
			infoDetailsVehicleList: [],
			infoDetailsWaypointList: [],
			dataHeaderWaypoint: {},
			selectedInfoDetails: null,
			tableDataKey: 1,
			resourceTableItemSelected: null,
			visitPointsRouted: 0,
			currentResourceSelected: "",
			ResourcesRouted: 0,
			ResourcesNotRouted: 0,
			currentRouteData: {},
			TableHeight: 0,
			countErrorView: 0,
			gridApi: null,
			gridOptions: {},
			selected: [],
			selectedTerritory: [],
			showTerritories: false,
			territoryOptions: [],
			exportRouteModal: false,
			tableResourcesData: [],
			formatSelect: null,
			router_vehicles: [],
			routingApi: "",
			flRoutes: [],
			flRouteSelected: null,
			polylines: [],
			markersArray: [],
			fleetTimeTotal: 0,
			fleetVisitsTotal: 0,
			fletVehicleNoRouted: 0,
			fletVehicleTravelTotal: 0,
			hashDpto: false,
			cont: 0,
			mapStyleName: "blue_essence",
			standardOutput: null,
			routedVehicles: [],
			noRoutedVehicles: [],
			vehicleRoutesMap: new Map(),
			same_date: false,
			not_found_resources: false,
			activeLoading: false,
			showRoutes: false,
			lista: [],
			selectedErrors: null,
			scheduleModalErrors: false,
			selectedUsers: [],
			popupActive: false,
			popupCapacityActive: false,
			popupCostActive: false,
			showButton: false,
			value4: 30,
			routes: [],
			showControlBar: true,
			colores: [],
			dataRoute: [],
			indexValidation: null,
			capacityArray: [],
			vehicleObject: {},
			costObject: {},
			searchQuery: null,
			editable: true,
			isDragging: false,
			delayedDragging: false,
			is_check: true,
			is_statistics: false,
			activePrompt: false,
			errorsActive: false,
			showActionsWaypoint: false,
			optimizationErrors: [],
			drawnTerritories: [],
			dataOptimization: {},
			resultStandardInput: {},
			selectedTableRows: [], // Nueva propiedad para controlar la selección de la tabla
			listOrderColumn: fieldList.map((name, index) => {
				return {name, order: index + 1, is_check: true};
			}),
			defaultColDef: {
				minWidth: 150,
			},
			formatOptions: [
				{text: "XLSX", value: "xlsx"},
				{text: "CSV", value: "csv"},
				{text: "TXT", value: "txt"},
				{text: "JSON", value: "json"},
			],
			settings: {
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
		};
	},
	components: {
		RoutingSidebar,
		GoogleMaps,
		AgGridVue,
		flatPickr,
		VuePerfectScrollbar,
		RoutingResultVisitPoints,
		vSelect,
		OptimizationResult,
		ListSelectedDatarutasVisitPoints,
		draggable,
		OptimizationCreate,
		OptimizationErrors,
		VisitingPointDetails,
		ListSelectedDatarutasWapoints,
	},
	props: {
		routeKey: [String, Number],
		routeId: [String, Number],
	},
	async created() {
		if (!moduleRouting.isRegistered) {
			this.$store.registerModule("moduleRouting", moduleRouting);
			moduleRouting.isRegistered = true;
		}
		if (!moduleOptimization.isRegistered) {
			this.$store.registerModule("moduleOptimization", moduleOptimization);
			moduleOptimization.isRegistered = true;
		}
		this.markersArray = [];
		document.addEventListener("click", (e) => {
			if (e.target.matches(".streetview-routing-map")) {
				this.openStreetView();
			}
		});
		await this.loadRoutes();
		// Ponemos un timeout para pintar los puntos en el mapa correctamente.
		if (this.showControlBar) this.createControlBar();
		setTimeout(() => {
			this.noRoutedVisitPoints();
			this.loadPoints();
		}, 2000);
	},
	watch: {
		getCurrentLocale() {
			this.showRoutes = false;
			// Verificar si Anuket está disponible antes de acceder
			const anuketObj = Anuket.getAnuketObj();
			if (anuketObj && anuketObj.map && typeof google !== "undefined" && google.maps) {
				anuketObj.map.controls[google.maps.ControlPosition.TOP_LEFT].clear();
				this.createControlBar();
			}
		},
		scheduleModal(val) {
			if (!val) {
				this.isInfoDetails = false;
				this.isInfoWaypointDetails = false;
				this.showActionsWaypoint = false;
			}
		},
		showTerritories(val) {
			if (val) {
				this.getTerrirories(this.routedVehicles);
			}
		},
		is_check(val) {
			this.listOrderColumn.map((p) => (p.is_check = val));
		},
		exportRouteModal(val) {
			if (!val) this.orderList();
			this.is_check = true;
			this.is_statistics = false;
		},
	},
	filters: {
		secondsToMinutes(strTime) {
			let cal = strTime ? strTime.replace("s") : 0;
			return `${(parseInt(cal) / 60).toFixed(1)} mins`;
		},
		removeDecimals(num = 0.03) {
			return num.toFixed(1);
		},
	},
	computed: {
		validateCost() {
			return (cost) => {
				return cost.distance == null && cost.fixed == null && cost.time == null && cost.traveled_hour == null;
			};
		},
		thead_property_names() {
			return {
				n: "N",
				type: this.$t("Routing.Table.Type"),
				identification: this.$t("Routing.Table.Identification"),
				territoryId: this.$t("Territories.TerritoryID"),
			};
		},
		scheduleDetails() {
			return this.$store.state.moduleOptimization.scheduleList;
		},
		scheduleWaypointDetails() {
			return this.$store.state.moduleOptimization.scheduleWayPointList;
		},
		getStyleLoader() {
			return () => import(`@/components/Maps/themes/${this.mapStyleName}`);
		},
		mapAppearanceText() {
			return this.$t("Routing.Map.MapAppearance");
		},
		getCurrentLocale() {
			return this.$i18n.locale;
		},
		selectedRoutingType() {
			return this.$store.state.routingType;
		},
		selectedTypeVehicle() {
			return this.$store.state.moduleRoutingType.typeVehicle;
		},
		getRoutedVehicles() {
			if (!this.searchQuery || this.searchQuery.trim().length <= 0) {
				return this.routedVehicles;
			}
			return this.routedVehicles.filter((r) => {
				return r.vehicle_id.toLowerCase().includes(this.searchQuery.toLowerCase());
			});
		},
		dragOptions() {
			return {
				animation: 0,
				group: "description",
				disabled: false,
				ghostClass: "ghost",
			};
		},
		validateTypeFormats() {
			if (this.formatSelect != null) return this.formatSelect.value;
			return null;
		},
		standardInput() {
			return this.$store.state.moduleOptimization.standardInputList;
		},
		validFormPrompt() {
			return this.dataOptimization.nameOptimization != "";
		},
		getLoadCapacity() {
			return (dataVehicle, name) => {
				let loadCapacity = [];
				if (dataVehicle.load_capacity.length > 0) {
					loadCapacity = dataVehicle.load_capacity.filter((load) => load.name === name);
					return loadCapacity[0].amount;
				}
				return 0;
			};
		},
		getLoadCapacityPercentage() {
			return (dataVehicle, name) => {
				let loadCapacityPercentage = [];
				if (dataVehicle.load_capacity_percentage.length > 0) {
					loadCapacityPercentage = dataVehicle.load_capacity_percentage.filter((load) => load.name === name);
					return Math.round(loadCapacityPercentage[0].percentage);
				}
				return 0;
			};
		},
		chipColor() {
			return (value) => {
				if (value === 100.0) {
					return "success";
				}
				if (value >= 50.0 && value < 100.0) {
					return "warning";
				} else if (value >= 1.0 && value < 50.0) {
					return "primary";
				}
				return "primary";
			};
		},
	},
	methods: {
		capitalize(str) {
			return str.charAt(0).toUpperCase() + str.slice(1);
		},
		openStreetView() {
			if (this.currentMarkerInfo !== null) {
				this.$refs.GoogleMaps.openStreetView({
					cx: this.currentMarkerInfo.lng,
					cy: this.currentMarkerInfo.lat,
				});
			}
		},
		/**
		 * Mapea la información recibida vía props
		 * Crea todos los markers y rutas sobre el mapa al mismo tiempo
		 *
		 * @returns {undefined}
		 */
		loadPoints() {
			// Reset inicial
			Anuket.resetRoutesParty();
			this.markersArray = [];
			this.polylines = [];
			const infoWindow = new google.maps.InfoWindow();

			// Cache para SVG templates
			const svgTemplate = [
				'<?xml version="1.0"?>',
				'<svg width="26px" height="26px" viewBox="0 0 100 100" version="1.1" xmlns="http://www.w3.org/2000/svg">',
				'<circle stroke="#222" fill="{{ color }}" cx="50" cy="50" r="35"/>',
				"</svg>",
			].join("\n");

			// Procesar cada vehículo rutado
			this.routedVehicles.forEach((routedVehicle, vehicleIndex) => {
				this._processRoutedVehicle(routedVehicle, vehicleIndex, infoWindow, svgTemplate);
			});

			// Construir eventos de polilíneas al final
			Anuket.buildPolylineEvents(this.polylines, this.confirmChange);
		},

		/**
		 * Procesa un vehículo rutado individual
		 * @param {Object} routedVehicle - Vehículo rutado
		 * @param {number} vehicleIndex - Índice del vehículo
		 * @param {google.maps.InfoWindow} infoWindow - Ventana de información
		 * @param {string} svgTemplate - Template SVG para marcadores
		 */
		_processRoutedVehicle(routedVehicle, vehicleIndex, infoWindow, svgTemplate) {
			// Inicializar estructuras de datos para este vehículo
			this.rutas[vehicleIndex] = {
				id: vehicleIndex,
				data: [],
				color: routedVehicle.color,
			};
			this.markers[vehicleIndex] = [];
			this.mapMarkerPolyline = [];

			// Filtrar puntos válidos (excluir breaks)
			const validPoints = routedVehicle.routed_visit_points.filter((point) => point.type !== "break");

			// Procesar cada punto válido
			validPoints.forEach((point, pointIndex) => {
				this._processVisitPoint(point, pointIndex, routedVehicle, vehicleIndex, svgTemplate);
			});

			// Procesar polilínea si existe
			this._processPolyline(routedVehicle, vehicleIndex, infoWindow);

			// Ajustar vista del mapa
			Anuket.fitBoundsMarkerGroup(this.markersArray);
		},

		/**
		 * Procesa un punto de visita individual
		 * @param {Object} point - Punto de visita
		 * @param {number} pointIndex - Índice del punto
		 * @param {Object} routedVehicle - Vehículo rutado
		 * @param {number} vehicleIndex - Índice del vehículo
		 * @param {string} svgTemplate - Template SVG
		 */
		_processVisitPoint(point, pointIndex, routedVehicle, vehicleIndex, svgTemplate) {
			const {latitude: lat, longitude: lng} = point;
			const marker = this._createMarker(point, pointIndex, routedVehicle, svgTemplate);

			if (marker) {
				this.markersArray.push(marker);
				this.markers[vehicleIndex].push({
					marker: marker,
					index: pointIndex,
					location: {lat, lng},
				});
				this.rutas[vehicleIndex].data.push([lat, lng]);
			}
		},

		/**
		 * Crea un marcador según el tipo de punto
		 * @param {Object} point - Punto de visita
		 * @param {number} pointIndex - Índice del punto
		 * @param {Object} routedVehicle - Vehículo rutado
		 * @param {string} svgTemplate - Template SVG
		 * @returns {Object} Marcador creado
		 */
		_createMarker(point, pointIndex, routedVehicle, svgTemplate) {
			const {latitude: lat, longitude: lng} = point;
			if (point.type === "depot") {
				return this._createDepotMarker(point, pointIndex, routedVehicle, {lat, lng});
			} else {
				return this._createVisitPointMarker(point, routedVehicle, {lat, lng}, svgTemplate);
			}
		},

		/**
		 * Crea un marcador de depósito
		 * @param {Object} point - Punto de depósito
		 * @param {number} pointIndex - Índice del punto
		 * @param {Object} routedVehicle - Vehículo rutado
		 * @param {Object} coords - Coordenadas
		 * @returns {Object} Marcador de depósito
		 */
		_createDepotMarker(point, pointIndex, routedVehicle, coords) {
			const options = {
				draggable: false,
				icon: pointIndex === 0 ? dptoImg : dptoImgEnd,
				title: point.identification,
				info: {vehicle_id: routedVehicle.vehicle_id},
				zIndex: 1,
				label: {
					text: "A",
					color: "#000",
					fontSize: "14px",
				},
				infoWindow: {
					content: generateInfowindowContentDeposit.call(this, pointIndex),
				},
				onClick: (e, coords) => {
					this.infoWindowSelected = e.infoWindow;
					this.currentMarkerInfo = coords;
				},
			};

			return Anuket.addMarker(coords, options);
		},

		/**
		 * Crea un marcador de punto de visita
		 * @param {Object} point - Punto de visita
		 * @param {Object} routedVehicle - Vehículo rutado
		 * @param {Object} coords - Coordenadas
		 * @param {string} svgTemplate - Template SVG
		 * @returns {Object} Marcador de punto de visita
		 */
		_createVisitPointMarker(point, routedVehicle, coords, svgTemplate) {
			const svg = svgTemplate.replace("{{ color }}", `#${routedVehicle.color}`);
			const options = {
				draggable: false,
				zIndex: 2,
				icon: {
					url: "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(svg),
					scaledSize: new google.maps.Size(20, 20),
				},
				title: point.identification,
				info: {
					vehicle_id: routedVehicle.vehicle_id,
					color: routedVehicle.color,
					visitPoints: routedVehicle.routed_visit_points.filter((point) => point.type !== "break"),
					dataVisitPoint: point,
				},
				label: {
					text: "A",
					color: "#000",
					fontSize: "14px",
				},
				infoWindow: {
					content: generateInfowindowContentPoint.call(this, point, "routed"),
				},
				onClick: (e, coords) => {
					this.infoWindowSelected = e.infoWindow;
					this.currentMarkerInfo = coords;
				},
			};

			const marker = Anuket.addMarker(coords, options);
			this.mapMarkerPolyline.push(marker);
			return marker;
		},

		/**
		 * Procesa la polilínea de un vehículo
		 * @param {Object} routedVehicle - Vehículo rutado
		 * @param {google.maps.InfoWindow} infoWindow - Ventana de información
		 */
		_processPolyline(routedVehicle, infoWindow) {
			if (!routedVehicle.encoded_polyline) return;

			const polylineOptions = {
				strokeColor: "#" + routedVehicle.color,
				strokeOpacity: 2,
				strokeWeight: 2,
				info: routedVehicle,
			};

			const polyline = Anuket.drawPolyline(routedVehicle.encoded_polyline, polylineOptions);
			polyline.mapMarkers = this.mapMarkerPolyline;
			this.polylines.push(polyline);

			// Agregar evento de clic a la polilínea
			google.maps.event.addListener(polyline, "click", (event) => {
				polyline.setOptions({strokeWeight: 4, strokeOpacity: 1});
				if (infoWindow) infoWindow.close();
				const content = generateInfowindowContentRoute.call(this, polyline, infoWindow);
				infoWindow.setContent(content);
				infoWindow.setPosition(event.latLng);
				infoWindow.open(Anuket.getAnuketObj().map);
			});

			// Guardar referencia en el mapa de rutas
			this.vehicleRoutesMap.set(routedVehicle.vehicle_id, routedVehicle.encoded_polyline);
		},
		confirmChange(changeList) {
			this.showButton = changeList.length > 0 ? true : false;
		},
		noRoutedVisitPoints() {
			// Pintamos los puntos que no se rutearon
			if (this.noRoutedVehicles.length > 0) {
				this.noRoutedVehicles.forEach((d) => {
					let lat = d.latitude;
					let lng = d.longitude;
					if (d.type === "depot") {
						Anuket.addMarker({lat, lng}, {});
					} else {
						let dropOptions = {
							draggable: false,
							icon: visitPointImg,
							title: "",
							label: {
								text: "A",
								color: "#000",
								fontSize: "14px",
							},
							infoWindow: {
								content: generateInfowindowContentPoint.call(this, d, "norouted"),
							},
							onClick: (e, coords) => {
								this.infoWindowSelected = e.infoWindow;
								this.currentMarkerInfo = coords;
							},
							onClose: () => {},
						};
						Anuket.addMarker({lat, lng}, dropOptions);
					}
				});
			}
		},

		/**
		 * @description Funcion para formatear la data de tal modo que agreguemos los index de los elementos
		 * solo de tipo point
		 * @param {Array} routedVisitPoints array de puntos de visita ruteados
		 */
		formarRoutedVP(routedVisitPoints = []) {
			let indexPoint = 0;
			return routedVisitPoints.map((rv) => {
				if (rv.type === "pickup" || rv.type === "delivery") {
					indexPoint += 1;
					rv["indexPoint"] = indexPoint;
				}
				return rv;
			});
		},
		/**
		 * Genera un color aleatorio en formato HEX
		 *
		 * @returns {string} - HEX Color string
		 */
		generateRandomHex() {
			let num = Math.floor(((1 + Math.random()) * Math.pow(16, 2)) / 2).toString(16);
			let characters = ["00", "FF", num];
			let color = "";
			for (let i = 0; i < 3; i++) {
				let character = Math.floor(Math.random() * characters.length);
				color += characters[character];
				characters.splice(character, 1);
			}
			if (this.colores.includes(color) || color.toString().length > 6) {
				return this.generateRandomHex();
			} else {
				this.colores.push(color);
			}
			return color;
		},
		exportRoute() {
			const payload = {
				optimization_id: parseInt(this.$route.params.id),
				vehicle_identifications: this.selected.map((vehicle) => vehicle.vehicle_id),
				file_type: this.formatSelect.value,
				vehicle_field_order: this.listOrderColumn.filter((field) => field.is_check).map((item) => item.name),
			};
			if (this.formatSelect.value === "xlsx" || this.formatSelect.value === "json")
				payload.get_vehicles_stats = this.is_statistics;

			// Mostrar loading dentro del modal con texto personalizado
			this.$vs.loading({
				container: "#export-route-modal-content",
				scale: 0.6,
				text: this.$t("Routing.Buttons.Downloading"),
			});

			this.$store
				.dispatch("moduleOptimization/exportOptimization", payload)
				.then(async (res) => {
					console.clear();
					const fileRef = this.$storage.ref().child(res.data.url);
					let filename = res.data.filename;

					try {
						const url = await fileRef.getDownloadURL();
						const response = await fetch(url);
						const blob = await response.blob();
						saveAs(blob, filename);

						// Cerrar loading y mostrar éxito
						this.$vs.loading.close("#export-route-modal-content > .con-vs-loading");

						this.$vs.notify({
							color: "success",
							title: this.$t("Success"),
							text: this.$t("Routing.Map.ExportRoute.Success"),
						});

						// Resetear selección pero mantener modal abierto
						this.formatSelect = null;
						this.selected = [];
					} catch (downloadError) {
						console.error("DOWNLOAD ERROR", downloadError);
						this.$vs.loading.close("#export-route-modal-content > .con-vs-loading");
						this.$vs.notify({
							color: "danger",
							title: this.$t("Error"),
							text: this.$t("Routing.Map.ExportRoute.DownloadError"),
						});
					}
				})
				.catch((err) => {
					console.error("EXPORT ROUTE ERROR", err);
					this.$vs.loading.close("#export-route-modal-content > .con-vs-loading");
					this.$vs.notify({
						color: "danger",
						title: this.$t("Error"),
						text: this.$t("Routing.Map.ExportRoute.Error"),
					});
					console.error(err);
				});
		},
		/**
		 * Cierra la tabla informativa de la ruta seleccionada
		 *
		 * @returns {undefined}
		 */
		closeResourceSelected() {
			const cardRouteList = document.getElementById(`card-route${this.indexValidation}`);
			if (cardRouteList) {
				cardRouteList.removeAttribute("style");
			}
			this.isARouteSelected = false;
			this.selectedTableRows = []; // Limpiar la selección de la tabla
			this.indexValidation = null; // Limpiar el índice de validación
			// Restablecer showRoute = true para todas las rutas
			this.routedVehicles.forEach((routedVehicle) => {
				routedVehicle.showRoute = true;
			});
			this.seeAllRoutes();
		},
		/**
		 * Abrimos el modal y reseteamos los campos de formato y recursos seleccionados a vacio
		 *
		 * @returns {undefined}
		 */
		exportModal() {
			this.exportRouteModal = true;
			this.formatSelect = null;
			this.selected = [];
		},
		/**
		 * Animamos un marker, aplicando la animación BOUNCE,
		 * @param {markerFound} markerFound - Elemento marker en el array de markers
		 * @returns {undefined}
		 */
		animateMarker(markerFound) {
			this.markersArray.forEach((m) => m.setAnimation(null));
			markerFound.setAnimation(google.maps.Animation.BOUNCE);
		},
		handleSelected(row) {
			const markerFound = this.markersArray.find((m) => m.title === row.identification);
			if (markerFound) {
				this.animateMarker(markerFound);
				Anuket.fitBounds(markerFound, "marker");
			}
		},
		/**
		 * Vuelve a cargar todas las rutas y oculta la tabla
		 * @returns {undefined}
		 */
		seeAllRoutes() {
			if (this.routingApi) {
				this.toggleAll();
			} else {
				Anuket.clearMap();
			}
			this.isARouteSelected = false;
		},
		/**
		 * Abrimos un prompt para confirmar si el usuario quiere eliminar la ruta actual
		 *
		 * @returns {undefined}
		 */
		deleteRoutePrompt() {
			this.exportRouteModal = false;
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Confirm"),
				text: this.$t("Routing.Map.DeleteRoute.DeleteRouteAsk"),
				accept: this.deleteRoute,
				acceptText: this.$t("Accept"),
				cancelText: this.$t("Cancel"),
			});
		},
		/**
		 * Eliminamos la ruta actual
		 *
		 * @returns {undefined}
		 */
		deleteRoute() {
			const key = this.routeKey;
			const routeId = this.routeId;
			Api.delete("/routingdone/" + key + "/" + routeId)
				.then((res) => {
					this.routeResultModal = false;
					this.exportRouteModal = false;
					this.$vs.notify({
						color: "success",
						title: this.$t("Success"),
						text: this.$t("Routing.Map.DeleteRoute.Success"),
					});
				})
				.catch((err) => {
					console.error("Error delete route", err);
				});
		},
		openScheduleModal() {
			this.scheduleModal = true;
			this.selected = [];
		},
		async scheduleRoute() {
			this.$vs.loading({
				container: "#schedule-with-loading",
				scale: 1,
			});
			const payload = {
				optimization_id: parseInt(this.$route.params.id),
				vehicle_identifications: this.selected.map((e) => e.vehicle_id),
			};
			if (this.typeSchedule === "waypoint" && this.includeDepots) payload.include_depots = this.includeDepots;
			try {
				let apiResponse;
				if (this.typeSchedule === "waypoint") {
					this.routedVehicles.map((data) => (data.showSchedule = false));
					this.selected.forEach((vehicle) => (vehicle.showSchedule = true));
					await this.$store
						.dispatch("moduleOptimization/scheduleOptimizationWithWaypoints", payload)
						.then((res) => {
							this.showActionsWaypoint = true;
						});
				} else if (this.countErrorView > 0) {
					this.scheduleDetails.events.forEach((item) => delete item.errorFound);
					apiResponse = await Api.post("/datarutas/create_events", {events: this.scheduleDetails.events});
				} else {
					const optimizationResponse = await this.$store.dispatch(
						"moduleOptimization/scheduleOptimization",
						payload
					);
					if (optimizationResponse.data.error.length > 0) {
						this.handleOptimizationRouterErrors(
							optimizationResponse.data.error,
							optimizationResponse.data.events
						);
						return;
					}
					apiResponse = await Api.post("/datarutas/create_events", {
						events: optimizationResponse.data.events,
					});
				}
				this.handleRouterSuccess(apiResponse.data);
			} catch (error) {
				this.handleApiError(error);
			} finally {
				this.$vs.loading.close("#schedule-with-loading > .con-vs-loading");
			}
		},
		handleOptimizationRouterErrors(errors, events) {
			let hash = {};
			this.is_error_schedule = false;
			this.arrayError = errors.filter((item) => {
				const exists = !hash[item.absolute_path[0]];
				hash[item.absolute_path[0]] = true;
				return exists;
			});
			this.routedVehicles.forEach((data) => (data.showErrorSchedule = false));
			this.selected.forEach((vehicle) => {
				const valid = events.some((item) => vehicle.vehicle_id != item.resource_id);
				vehicle.showErrorSchedule = valid;
			});
			this.is_error_schedule = true;
			this.$vs.notify({
				color: "danger",
				title: this.$t("Schedule"),
				text: `${this.$t("Routing.Map.Schedule.ErrorOptimization")}`,
				time: 7000,
			});
		},
		handleRouterSuccess(data) {
			this.selected = [];
			this.scheduleModal = false;
			this.$vs.notify({
				color: "success",
				title: this.$t("Schedule"),
				text: `${data.length} ${this.$t("Routing.Map.Schedule.Success")}`,
				time: 5000,
			});
			this.is_error_schedule = false;
			this.isInfoDetails = false;
			this.isInfoWaypointDetails = false;
			this.countErrorView = 0;
			this.$store.commit("moduleOptimization/DELETE_ALL_VISIT_POINTS_SELECTED_SCHEDULE_DATARUTAS");
		},
		closeSchedule() {
			this.selected = [];
			this.is_error_schedule = false;
			this.isInfoDetails = false;
			this.countErrorView = 0;
		},
		async handleApiError(error) {
			if (error.error && error.error.length > 0) {
				this.$vs.notify({
					color: "warning",
					title: this.$t("Schedule"),
					text: this.$t("Routing.Map.Schedule.FoundErrors"),
					time: 5000,
				});
				this.lista = error.error.map((er) => {
					const messageTranslate = this.messageValidator(er.message);
					return {...er, message: messageTranslate};
				});
				this.scheduleModal = false;
				this.scheduleModalErrors = true;
			}
			return error;
		},
		/**
		 * Carga una ruta individual, con sus marker eliminando las polilineas actuales
		 * @param {id} id - Id del recurso sobre el cual se pintaran las polilineas
		 * @returns {undefined}
		 */
		cargarRutaIndividual(data, index) {
			this.indexValidation = index;
			this.dataRoute = data;
			if (this.showButton) {
				this.$vs.dialog({
					type: "confirm",
					color: "danger",
					title: this.$t("Confirm"),
					text: `${this.$t("Routing.ValidateChangesReOptimize")}`,
					accept: this.cancelChangeRoute,
					cancel: this.cancelButton,
					acceptText: this.$t("Routing.ValidateMessages.Yes"),
					cancelText: this.$t("Routing.ValidateMessages.Not"),
				});
			} else {
				this.isARouteSelected = true;
				this.isVisitPointSelected = false;
				this.toggleRoutes(data);
			}
		},
		toggleRoutes(data) {
			// Establecer showRoute = false para la ruta seleccionada y true para las demás
			this.routedVehicles.forEach((routedVehicle) => {
				routedVehicle.showRoute = routedVehicle.vehicle_id === data.vehicle_id ? false : true;
			});

			this.currentRouteData = data;
			if (this.flRouteSelected) {
				// Ocultar / Mostrar polylineas o rutas
				const polylinesToHidde = this.polylines.filter((poly) => poly.info.vehicle_id !== data.vehicle_id);
				const polylinesToShow = this.polylines.filter((poly) => poly.info.vehicle_id === data.vehicle_id);
				polylinesToShow.forEach((poly) => {
					Anuket.addLine(poly);
				});
				polylinesToHidde.forEach((poly) => {
					Anuket.removeLine(poly);
				});
				// Ocultar / Mostrar markers
				const markersToShow = this.markersArray.filter((t) => t.details.vehicle_id === data.vehicle_id);
				let indexPoint = 0;
				data.routed_visit_points.forEach((rv) => {
					if (rv.type === "pickup" || rv.type === "delivery") {
						indexPoint += 1;
						const iconInit = Utils.addIconSvgWithLabel(data.color, indexPoint);
						// Encontrar el marcador correcto usando el identificador del punto
						const markerToUpdate = markersToShow.find(
							(marker) =>
								marker.title === rv.identification &&
								marker.details.dataVisitPoint &&
								marker.details.dataVisitPoint.type !== "depot"
						);
						if (markerToUpdate) {
							markerToUpdate.setIcon(iconInit);
						}
					}
				});
				const markersToHidde = this.markersArray.filter((t) => t.details.vehicle_id !== data.vehicle_id);
				Anuket.hideMarkers(markersToHidde);
				Anuket.showMarkers(markersToShow);
				// Zoom sobre los markers que quedan visibles
				Anuket.fitBoundsMarkerGroup(markersToShow);
			} else {
				// Aqui entramos la primera vez que se selecciona una ruta, por ello solo se ocultan rutas y markers
				this.polylines
					.filter((poly) => poly.info.vehicle_id !== data.vehicle_id)
					.forEach((poly) => {
						Anuket.removeLine(poly);
					});
				// Ocultar markers
				const markersToHidde = this.markersArray.filter((t) => t.details.vehicle_id !== data.vehicle_id);
				const markersToShow = this.markersArray.filter((t) => t.details.vehicle_id === data.vehicle_id);
				Anuket.hideMarkers(markersToHidde);
				let indexPoint = 0;
				data.routed_visit_points.forEach((rv) => {
					if (rv.type === "pickup" || rv.type === "delivery") {
						indexPoint += 1;
						const iconInit = Utils.addIconSvgWithLabel(data.color, indexPoint);
						// Encontrar el marcador correcto usando el identificador del punto
						const markerToUpdate = markersToShow.find(
							(marker) =>
								marker.title === rv.identification &&
								marker.details.dataVisitPoint &&
								marker.details.dataVisitPoint.type !== "depot"
						);
						if (markerToUpdate) {
							markerToUpdate.setIcon(iconInit);
						}
					}
				});
				// Zoom sobre los markers que quedan visibles
				Anuket.fitBoundsMarkerGroup(markersToShow);
			}
			this.flRouteSelected = data;
			this.flRouteSelected["visits"] = data.routed_visit_points
				.filter((element) => element.type !== "break")
				.map((element, index) => ({
					...element,
					index: index + 1,
				}));
			this.clearTerritories();
			this.selectedTerritory = [];
			this.tableData = this.formarRoutedVP(data.routed_visit_points);
		},
		toggleAll() {
			// Mostrar polylineas o rutas
			this.polylines.forEach((poly) => {
				Anuket.addLine(poly);
			});
			this.markersArray.forEach((marker) => {
				if (marker.details.visitPoints != undefined && marker.details.visitPoints.length > 0) {
					marker.details.visitPoints.forEach((point) => {
						if (point.type === "pickup" || point.type === "delivery") {
							const iconInit = Utils.addIconSvgWithLabelSmall(marker.details.color);
							marker.setIcon(iconInit);
							marker.setAnimation(null);
						}
					});
				}
			});
			// Mostrar markers
			Anuket.showMarkers(this.markersArray);
			// Zoom sobre los markers que quedan visibles
			Anuket.fitBoundsMarkerGroup(this.markersArray);
			this.clearTerritories();
			this.selectedTerritory = [];
		},
		changeMapType(mapType) {
			this.mapTypeSelected = mapType;
			Anuket.setMapType(mapType);
			if (mapType === "roadmap") {
				this.changeMapStyle("blue_essence");
			}

			if (mapType === "dark") {
				this.changeMapStyle("dark_theme_without_places");
			}
		},
		changeMapStyle(styleName) {
			this.mapStyleName = styleName;
			this.getStyleLoader().then((res) => {
				Anuket.setMapStyle({
					styleMapName: styleName,
					styles: res.default,
					mapTypeId: styleName,
				});
			});
		},
		addDaysToDate(stringDate, dayNums) {
			const date = new Date(stringDate);
			return date.setDate(date.getDate() + dayNums);
		},
		findText(searhStr, str) {
			return str.search(searhStr) != -1;
		},
		messageValidator(message) {
			if (this.findText("The resource_identification", message))
				return this.$t("Routing.Map.Schedule.ErrorResource");
			else if (this.findText("activity_id", message))
				return "El recurso no tiene la actividad asignada al ruteo.";
			else if (this.findText("time data", message)) return this.$t("Routing.Map.Schedule.Error");
			else if (message === "init_hour less than current time")
				return this.$t("Routing.Map.Schedule.InitHourError");
			else if (message === "visit point is not related to resource")
				return this.$t("Routing.Map.Schedule.VisitpointError");
			else if (message === "activity not available for the resource")
				return this.$t("Routing.Map.Schedule.ResourceActivityError");
			else return message;
		},
		generateCurrentDateStr() {
			const currentDate = new Date().toLocaleDateString().split("/").reverse().join("-");
			const dateFinalMilisecods = this.addDaysToDate(currentDate, -2);
			const dateFinal = DateUtils.toDefaultDateTime(new Date(dateFinalMilisecods), "YYYY-MM-DD");
			return dateFinal;
		},
		openInitialLoading() {
			this.$vs.loading({
				scale: 1,
			});
			setTimeout(() => {
				this.$vs.loading.close();
			}, 8000);
		},
		createControlBar() {
			// Verificar si Google Maps y Anuket están disponibles
			if (typeof google === "undefined" || typeof google.maps === "undefined") {
				console.warn("Google Maps not loaded yet, retrying createControlBar...");
				setTimeout(() => {
					this.createControlBar();
				}, 100);
				return;
			}

			// Verificar si Anuket está inicializado
			const anuketObj = Anuket.getAnuketObj();
			if (!anuketObj || !anuketObj.map) {
				console.warn("Anuket map not initialized yet, retrying createControlBar...");
				setTimeout(() => {
					this.createControlBar();
				}, 100);
				return;
			}

			const centerControlDiv = document.createElement("div");
			centerControlDiv.style.cssText = `margin-top: 5px;margin-left: 15px;z-index: 0;position: absolute;left: 0px;top: 0px;`;
			customMapsControl.call(this, centerControlDiv);
			anuketObj.map.controls[google.maps.ControlPosition.TOP_LEFT].push(centerControlDiv);
		},
		downloadStandardOutput(bucketPath) {
			if (!bucketPath) return;
			const fileRef = this.$storage.ref().child(bucketPath);
			fileRef.getDownloadURL().then(async (url) => {
				const response = await fetch(url);
				const data = await response.json();
				Object.assign(this.standardOutput, data);
				this.routedVehicles = this.standardOutput.routed_vehicles.map((vehicle) => {
					vehicle["color"] = this.generateRandomHex();
					vehicle["check"] = true;
					vehicle["showRoute"] = true;
					vehicle["showErrorSchedule"] = false;
					vehicle["showSchedule"] = false;
					return vehicle;
				});
				this.$store.commit("moduleRouting/SET_STANDARD_OUTPUT", {
					...this.standardOutput,
					routed_vehicles: this.routedVehicles,
				});
				this.noRoutedVehicles = this.standardOutput.not_routed_visit_points;
			});
		},
		toggleCloseSidebar() {
			this.showRoutes = false;
			this.closeResourceSelected();
			const btnRoutes = document.getElementById("btn-toggle-routes");
			document.getElementById("ul-map-types").style.display = "none";
			btnRoutes.title = this.$t("Routing.RouteResult.SeeRoutes");
			btnRoutes.innerHTML = "";
			addIconToBtn(btnRoutes, "icon-eye");
		},
		async loadRoutes() {
			const payload = {
				optimization_id: parseInt(this.$route.params.id),
				file_type: "standard_output",
			};
			this.openInitialLoading();
			this.$store
				.dispatch("moduleOptimization/findById", payload)
				.then((res) => {
					this.standardOutput = res.data;
					this.routingApi = this.selectedRoutingType;
					if (res.data.from_file) {
						const bucketPath = this.standardOutput.bucket_path;
						this.downloadStandardOutput(bucketPath);
						return;
					}
					this.routedVehicles = this.standardOutput.routed_vehicles.map((vehicle) => {
						vehicle["color"] = this.generateRandomHex();
						vehicle["check"] = true;
						vehicle["showRoute"] = true;
						vehicle["showErrorSchedule"] = false;
						vehicle["showSchedule"] = false;
						return vehicle;
					});
					this.$store.commit("moduleRouting/SET_STANDARD_OUTPUT", {
						...this.standardOutput,
						routed_vehicles: this.routedVehicles,
					});
					this.noRoutedVehicles = this.standardOutput.not_routed_visit_points;
				})
				.catch((err) => {
					console.error(err);
				});
		},
		cancelChange() {
			Anuket.cancelChangeMarkers(this.polylines, this.markersArray);
			this.showButton = false;
		},
		async cancelChangeRoute() {
			Anuket.cancelChangeMarkers(this.polylines, this.markersArray);
			this.showButton = false;
			this.isARouteSelected = true;
			this.isVisitPointSelected = false;
			await this.toggleRoutes(this.dataRoute);
		},
		async ConfirmCancelChange() {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Confirm"),
				text: `${this.$t("Routing.ValidateMessages.Text")}`,
				accept: this.cancelChange,
				acceptText: this.$t("Routing.ValidateMessages.Yes"),
				cancelText: this.$t("Routing.ValidateMessages.Not"),
			});
		},
		cancelButton() {
			const cardRouteList = document.getElementById(`card-route${this.indexValidation}`);
			cardRouteList.removeAttribute("style");
		},
		async generateOptimization() {
			console.clear();
			const payload = this.createPayload();
			this.assignAllowedVehicles();
			this.$vs.loading();
			try {
				const res = await this.$store.dispatch("moduleOptimization/optimization", payload);
				this.handleResponse(res);
			} catch (err) {
				this.$vs.loading.close();
				console.error(err);
			}
		},
		createPayload() {
			const payload = {
				name: this.dataOptimization.nameOptimization,
				vehicles: this.resultStandardInput["vehicles"],
				routing_api: this.selectedRoutingType,
				global_config: {
					init_date: DateUtils.toDefaultDateTime(this.dataOptimization.period.init_date, "YYYY-MM-DD"),
					end_date: DateUtils.toDefaultDateTime(this.dataOptimization.period.end_date, "YYYY-MM-DD"),
					init_hour: this.dataOptimization.period.init_hour,
					end_hour: this.dataOptimization.period.end_hour,
				},
			};
			if (this.resultStandardInput.hasOwnProperty("pickups") && this.resultStandardInput["pickups"].length > 0) {
				payload.pickups = this.resultStandardInput["pickups"];
			}
			if (
				this.resultStandardInput.hasOwnProperty("deliveries") &&
				this.resultStandardInput["deliveries"].length > 0
			) {
				payload.deliveries = this.resultStandardInput["deliveries"];
			}
			if (this.dataOptimization.group) {
				payload.optimization_group_id = this.dataOptimization.group.value;
			}
			if (this.selectedRoutingType === "OPENROUTE") {
				payload.global_config.mesh = this.dataOptimization.mesh.value;
			}
			if (this.selectedRoutingType === "TOUR_PLANNING" || this.selectedRoutingType === "GMPRO") {
				if (this.dataOptimization.objectiveListSelected && this.dataOptimization.objectiveListSelected.length) {
					payload.global_config.objectives = this.dataOptimization.objectiveListSelected.map(
						(data) => data.value
					);
				}
			}
			if (this.selectedRoutingType === "TOUR_PLANNING") {
				payload.global_config.live_traffic = this.dataOptimization.liveTraffic;
				if (this.dataOptimization.advanced_objectives && this.dataOptimization.advanced_objectives.length) {
					payload.global_config.advanced_objectives = this.dataOptimization.advanced_objectives;
				}
			}
			return payload;
		},
		assignAllowedVehicles() {
			this.routedVehicles.forEach((vehicle) => {
				vehicle.routed_visit_points.forEach((visitPoint) => {
					if (vehicle.check && visitPoint.type !== "depot") {
						visitPoint.allowed_vehicles = [vehicle.vehicle_id];
						if (visitPoint.type === "pickup") {
							this.assignToStandardInput("pickups", visitPoint);
						} else if (visitPoint.type === "delivery") {
							this.assignToStandardInput("deliveries", visitPoint);
						}
					}
				});
			});
		},
		assignToStandardInput(type, visitPoint) {
			const item = this.resultStandardInput[type].find(
				(entry) => entry.identification === visitPoint.identification
			);
			if (item) {
				item.allowed_vehicles = [visitPoint.allowed_vehicles[0]];
			}
		},
		handleResponse(res) {
			if (res.status === 200) {
				this.handleSuccess();
			} else if (res.data.status === 400) {
				this.notifyError("Optimization.Messages.Unknown");
			} else if (res.data.optimizer.status === 400) {
				this.handleOptimizationErrors(res.data.optimizer);
			}
			this.$vs.loading.close();
		},
		handleSuccess() {
			this.showControlBar = false;
			this.$vs.notify({
				title: this.$t("Routing.CreateVisitPoint.Success.Proccesing"),
				text: this.$t("Routing.HistoricalReOptimizationText"),
				time: 8000,
			});
			this.$router.push({name: "OptimizationList"});
		},
		notifyError(messageKey) {
			this.$vs.notify({
				color: "danger",
				title: this.$t("ErrorTitle"),
				text: this.$t(messageKey),
			});
		},
		handleOptimizationErrors(optimizer) {
			this.optimizationErrors = this.extractErrors(optimizer.data).concat(this.extractErrors(optimizer.error));
			this.errorsActive = true;
		},
		extractErrors(errors) {
			return (
				errors.map((err) => ({
					message: err.validator || err.message,
					absolutePath: err.absolute_path.join("/"),
				})) || []
			);
		},
		showPopupCapacities(vehicle) {
			this.vehicleObject = vehicle;
			this.capacityArray = vehicle.vehicle_capacity;
			this.popupCapacityActive = true;
		},
		showPopupCosts(costs) {
			this.costObject = costs;
			this.popupCostActive = true;
		},
		seeDetailInformation(data) {
			const dataFilter = this.scheduleDetails.events.filter((event, index) => {
				if (
					this.arrayError.length > 0 &&
					this.arrayError[index] &&
					this.arrayError[index].hasOwnProperty("absolute_path")
				) {
					if (index === this.arrayError[index].absolute_path[0])
						event.errorFound = this.scheduleDetails.error.filter(
							(error) => error.absolute_path[0] === index
						);
					return event;
				}
				return [];
			});
			this.infoDetailsVehicleList = dataFilter;
			this.selectedInfoDetails = data.vehicle_id;
			this.isInfoDetails = true;
			this.countErrorView += 1;
		},
		seeWaypointDetailInformation(data, indexWaypoint) {
			const dataFilter = this.scheduleWaypointDetails.map((schedule, index) => {
				if (index === indexWaypoint) return schedule;
			});
			this.infoDetailsWaypointList = dataFilter[indexWaypoint].waypoints;
			const {activity_id, date_end, date_init, resource_id} = dataFilter[indexWaypoint];
			this.dataHeaderWaypoint = {activity_id, date_init, date_end, resource_id};
			this.selectedInfoDetails = data.vehicle_id;
			this.isInfoWaypointDetails = true;
		},
		backSchedule() {
			if (this.typeSchedule === "waypoint") {
				this.isInfoWaypointDetails = false;
				return;
			}
			const validateData = this.infoDetailsVehicleList.filter(
				(event) => event.activity_id === null || event.visit_point_id === null || event.resource_id === null
			);
			if (validateData.length > 0) {
				this.$vs.dialog({
					type: "confirm",
					color: "danger",
					title: this.$t("Confirm"),
					text: this.$t("YouWishToLeaveEven"),
					accept: () => {
						this.isInfoDetails = false;
						this.is_success_schedule = false;
					},
					cancel: () => {
						this.isInfoDetails = true;
					},
					acceptText: this.$t("Routing.ValidateMessages.Yes"),
					cancelText: this.$t("Routing.ValidateMessages.Not"),
				});
			} else {
				this.isInfoDetails = false;
				this.is_success_schedule = true;
			}
		},
		orderList() {
			this.listOrderColumn = this.listOrderColumn.sort((one, two) => {
				return one.order - two.order;
			});
		},
		showPrompt() {
			this.$vs.loading();
			this.$store
				.dispatch("moduleOptimization/findById", {
					optimization_id: parseInt(this.$route.params.id),
					file_type: "standard_input",
				})
				.then((res) => {
					this.$vs.loading.close();
					this.resultStandardInput = res.data;
					this.dataOptimization = {
						nameOptimization: res.data.name,
						selectedRouter: this.selectedRoutingType,
						selectedVehicleProfile: this.selectedTypeVehicle,
						profileOption: "general",
						period: {
							init_date: res.data["global_config"].init_date,
							end_date: res.data["global_config"].end_date,
							init_hour: res.data["global_config"].init_hour,
							end_hour: res.data["global_config"].end_hour,
						},
					};
					this.activePrompt = true;
				})
				.catch(() => {
					this.$vs.loading.close();
				});
		},
		acceptPrompt() {
			if (this.selectedRoutingType === "OPENROUTE" && !this.dataOptimization.hasOwnProperty("mesh")) {
				this.activePrompt = true;
				return;
			}
			this.generateOptimization();
		},
		optimizationFields(data) {
			this.dataOptimization = data;
		},
		activePopup(val) {
			this.errorsActive = val;
		},
		showVisitPointDetails(point) {
			this.routedVehicles.flatMap((item) =>
				item.routed_visit_points
					.filter((item) => item.type !== "depot" && item.identification === point.identification)
					.map(() => {
						point["vehicleId"] = item.vehicle_id;
						point["color"] = item.color;
					})
			);
			this.visitPointDetails = point;
			this.isARouteSelected = false;
			this.showRoutes = false;
			this.isVisitPointSelected = true;
		},
		closeSidebar() {
			this.isARouteSelected = false;
			this.isVisitPointSelected = false;
			this.showRoutes = true;
		},
		showTerritoriesModal() {
			this.showTerritories = true;
		},
		getTerrirories(routedVehicles) {
			const territoryArray = [];
			routedVehicles.forEach((vehicle) => {
				vehicle.routed_visit_points.forEach((point) => {
					if (point.territory_id) {
						// Evitar duplicados de misma zona para mismo vehículo
						const existe = territoryArray.find(
							(z) => z.value === point.territory_id && z.vehicle_id === vehicle.vehicle_id
						);
						if (!existe) {
							territoryArray.push({
								label: `${point.territory_id} (${vehicle.vehicle_id})`,
								value: point.territory_id,
								vehicle_id: vehicle.vehicle_id,
							});
						}
					}
				});
			});
			this.territoryOptions = territoryArray;
		},
		clearTerritories() {
			this.drawnTerritories.forEach(({polygon, infoWindow}) => {
				if (polygon) polygon.setMap(null);
				if (infoWindow) infoWindow.close();
			});
			this.drawnTerritories = [];
		},
		removeTerritoryById(territoryId) {
			const zona = this.drawnTerritories.find((z) => z.territoryId === territoryId);
			if (!zona) return;
			if (zona.polygon) zona.polygon.setMap(null);
			if (zona.infoWindow) zona.infoWindow.close();
			this.drawnTerritories = this.drawnTerritories.filter((z) => z.territoryId !== territoryId);
			this.selectedTerritory = this.selectedTerritory.filter((t) => t.value !== territoryId);
		},
		showContextMenu(latLng, territoryId) {
			if (this.contextMenu) this.contextMenu.close();
			const content = `<div style="padding:5px; cursor:pointer;" id="eliminarTerritoryBtn">🗑️ Eliminar</div>`;
			const map = Anuket.getAnuketObj().map;
			this.contextMenu = new google.maps.InfoWindow({content, position: latLng});
			this.contextMenu.open(map);
			google.maps.event.addListenerOnce(this.contextMenu, "domready", () => {
				document.getElementById("eliminarTerritoryBtn").addEventListener("click", () => {
					this.removeTerritoryById(territoryId);
					this.contextMenu.close();
				});
			});
		},
		drawTerritoriesAroundSelectedPoints() {
			this.clearTerritories();
			const colors = ["#FF0000", "#00FF00", "#0000FF", "#FF00FF", "#00FFFF", "#FFA500", "#800080"];
			let colorIndex = 0;
			const groupedPoints = this.groupPointsByTerritory();
			const bounds = new google.maps.LatLngBounds();
			const map = Anuket.getAnuketObj().map;
			this.selectedTerritory.forEach(({value: territoryId, vehicle_id}) => {
				const territoryPoints = groupedPoints[territoryId];
				if (!territoryPoints || territoryPoints.length < 3) {
					this.$vs.notify({
						color: "danger",
						title: this.$t("Error"),
						text: this.$t("Territories.TerritoryDoesNotHaveEnough", {n: territoryId}),
						time: 7000,
					});
					return;
				}
				const polygon = this.generatePolygonTerritory(
					territoryPoints,
					colors[colorIndex % colors.length],
					bounds,
					map
				);
				if (!polygon) {
					return;
				}
				const centroid = turf.center(turf.featureCollection(territoryPoints.map((p) => turf.point(p.coords))))
					.geometry.coordinates;
				polygon.addListener("click", () => {
					this.infoWindowSelected = null;
					this.infoWindowSelected = this.createInfoWindow(
						map,
						centroid,
						territoryId,
						vehicle_id,
						territoryPoints
					);
					this.infoWindowSelected.open(map);
				});
				polygon.addListener("rightclick", (event) => {
					this.showContextMenu(event.latLng, territoryId);
				});
				this.drawnTerritories.push({polygon: polygon, territoryId});
				colorIndex++;
			});
			if (!bounds.isEmpty()) map.fitBounds(bounds);
			this.showTerritories = false;
		},
		groupPointsByTerritory() {
			const groupedPoints = {};
			this.routedVehicles.forEach((vehicle) => {
				vehicle.routed_visit_points.forEach((point) => {
					const territoryId = point.territory_id;
					if (!territoryId) return; // Ignorar puntos sin territory_id
					if (!groupedPoints[territoryId]) {
						groupedPoints[territoryId] = [];
					}
					groupedPoints[territoryId].push({
						coords: [point.longitude, point.latitude],
						visitPointId: point.identification,
					});
				});
			});
			return groupedPoints;
		},
		generatePolygonTerritory(territoryPoints, color, bounds, map) {
			const pointsGeoJson = turf.featureCollection(territoryPoints.map((p) => turf.point(p.coords)));
			const polygonHull = turf.convex(pointsGeoJson);
			if (!polygonHull) return null;
			const polygonPaths = polygonHull.geometry.coordinates[0].map(([lng, lat]) => {
				const latLng = new google.maps.LatLng(lat, lng);
				bounds.extend(latLng);
				return {lat, lng};
			});
			const polygon = new google.maps.Polygon({
				paths: polygonPaths,
				strokeColor: color,
				strokeOpacity: 0.8,
				strokeWeight: 2,
				fillColor: color,
				fillOpacity: 0.25,
			});
			polygon.setMap(map);
			return polygon;
		},
		createInfoWindow(map, centroid, territoryId, vehicle_id, territoryPoints) {
			const content = `
                <div class="flex items-center justify-between">
                    <div><strong>Territorio:</strong> ${territoryId}</div>
                    <button
                        id="btnCerrarInfoWindow"
                        class="bg-warning text-white rounded-full p-1 ml-2 cursor-pointer font-bold"
                    >x</button>
                </div>
                <div><strong>Vehiculo:</strong> ${vehicle_id}</div>
                <div><strong>Puntos de visita:</strong> ${territoryPoints.map((p) => p.visitPointId).join(", ")}</div>
            `;
			const infoWindow = new google.maps.InfoWindow({
				content,
				position: {lat: centroid[1], lng: centroid[0]},
			});
			google.maps.event.addListener(infoWindow, "closeclick", () => {
				infoWindow.close();
			});
			google.maps.event.addListener(infoWindow, "domready", () => {
				document.getElementById("btnCerrarInfoWindow").addEventListener("click", () => {
					infoWindow.close();
				});
			});
			return infoWindow;
		},
	},
};
</script>
<style lang="scss" scoped>
.map-custom-container {
	margin: -30px;
}

.scroll-area {
	margin: auto;
	width: 100%;
	min-height: auto;
	max-height: calc(95vh - 150px);
}

.scroll-area--export {
	margin: auto;
	width: 100%;
	min-height: auto;
	max-height: 350px;
}

.scroll-area-order {
	margin: auto;
	width: 100%;
	min-height: auto;
	max-height: 230px;
}

li:hover {
	background-color: #f5f5f5;
}
</style>
<style lang="scss">
.vs-popup-schedule-content {
	.vs-popup {
		width: 800px;
	}
}
.con-vs-dialog {
	z-index: 54000 !important;
}

.flip-list-move {
	transition: transform 0.5s;
}

.no-move {
	transition: transform 0s;
}

.ghost {
	opacity: 0.5;
	background: #c8ebfb;
}

.list-group {
	min-height: 20px;
}

.list-group-item {
	cursor: move;
}

.list-group-item i {
	cursor: pointer;
}
#map-google-optimization {
	/* Hide the default close button of the InfoWindow */
	.gm-ui-hover-effect {
		display: none !important;
	}
	.custom-info-window {
		padding: 10px;
		background-color: white;
		border: 1px solid #ccc;
		border-radius: 4px;
	}
}
#content-territory {
	.vs-table--header {
		display: flex;
		align-items: center;
		gap: 371px;
		flex-direction: row-reverse;
	}
}
</style>
